<style scoped>
    .expand-row{
        margin-bottom: 1px;
    }
</style>
<template>
    <div>
        <Row class="expand-row">
            <Col span="22">
              <tables border search-place="bottom" :stripe="true" :show-header="false" :loading="tableLoading" v-model="tableData" :columns="columns"/>
                <div style="margin: 10px 0; overflow: hidden;">
                <div style="float: left;">
                当前显示 {{ tableData.length }} 条记录，总共 {{ count }} 条记录
                </div>
                <div style="float: right;">
                <page :total="count" :current="page" :page-size="size" @on-change="getTableData"></page>
                </div>
            </div>
            </Col>
        </Row>
    </div>
</template>
<script>
import Tables from '_c/tables'
import { GetWorkSheetSonType, DeleteWorkSheetTypeSon } from '@/api/logistics/type'

export default {
  name: 'type-expand',
  components: {
    Tables
  },
  props: {
    row: Object,
    isTypeOperate: Boolean
  },
  data () {
    return {
      change: false,
      count: 0,
      size: 10,
      page: 1,
      tableLoading: false,
      columns: [
        { title: '分类名称', key: 'type_name', align: 'center' },
        {
          title: '操作',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  display: this.isTypeOperate ? 'inline-block' : 'none',
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params.row)
                  }
                }
              }, '编辑'),
              h('Poptip', {
                props: {
                  confirm: true,
                  title: '你确定要删除吗?'
                },
                on: {
                  'on-ok': () => {
                    this.delete(params.row)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    display: this.isTypeOperate ? 'inline-block' : 'none',
                    marginRight: '5px'
                  }
                }, '删除')
              ])
            ])
          }
        }
      ],
      tableData: [],
      changeLoadingShow: false,
      formItem: {
        id: 0,
        type_name: '',
        parent: null
      },
      all_user_list: [],
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        type_name: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    console.log(this.row)
    this.init()
  },
  methods: {
    // 初始化
    init () {
      this.getTableData()
    },
    // 获取表格数据
    getTableData (value = 1) {
      this.tableLoading = true
      this.page = value
      let params = {
        'size': this.size,
        'page': this.page,
        'parent_id': this.row.id
      }
      GetWorkSheetSonType(params).then(res => {
        console.log(res.data.results)
        this.tableData = res.data.results
        this.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
      })
    },
    // 编辑
    edit (row) {
      console.log(row.parent)
      this.formItem.id = row.id
      this.formItem.type_name = row.type_name
      this.formItem.parent = row.parent
      this.$emit('on-result-change', this.formItem)
    },
    // 删除
    delete (row) {
      DeleteWorkSheetTypeSon(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.init()
        this.$emit('on-delete-change')
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    }
  }
}
</script>
